var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 321.7 321.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#ffbd1d}.st7{fill:#ff4304}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.7 180.1s-37.9 2.5-88.4 9.4c-38.7 5.3-73-1.8-79.1-10.5-2.9-4.1 1.5-8.4 6-9.3 12.7-2.6 161.5 10.4 161.5 10.4z",
    fill: "#ff751d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 116.1c-4.1 0-24.2-1.2-33.2 7.8-9.1 9.1-5.3 22.6-23.5 28.2-18.2 5.6-54.6 17.5-54.6 17.5s17-1.8 42 2.6c25.1 4.4 104.7 33.6 128.6 33.6 23.8 0 41.4-1.9 47-12.5 0 0-49.5-18.6-66.2-26.7 0 0-3.4-3.7-3.4-13.4s2.8-15.1-8.3-26.2c-11.1-11.2-28.4-10.9-28.4-10.9z",
    fill: "#ff951d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.5 120.9s-16.4-2.1-20.1 7.9c-3.7 10-2.7 10.1 7 14.4 9.7 4.3 25.2 2.2 27.4-7.2s-10.2-15.1-14.3-15.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2 169.7c57.1-6.4 136.6 36.2 171.9 35.3 12 .1 31.7.1 41-6.6 1.9-1.4 3.5-3.1 4.7-5.1-4.4 8.3-15.1 10.8-24.5 12.1-7.8 1-19.6 1.6-28.4.9l-3.5-.5c-49.5-6.7-105.3-39-161.2-36.1z",
    fill: "#cc3403"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.4 166.1c1 0 2-.1 2.9-.2-.6-.9-1.8-3-2.4-6.5-8.2.4-18.6.4-27-.9-22.7-3.6-32.8-11.4-53.6-16.1-1.3 2.1-2.9 4-5.2 5.7 31.7 6.3 40.4 20.2 85.3 18z",
    fill: "#ff1932"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204.8 159.5c-5.3.3-11.5.4-17.5.1-.7 2.4-2.1 4.5-3.7 6.3 6 .5 12.8 1.3 20.8.9 1 0 2.4-.3 3.3-.3-.6-.9-2.2-3.5-2.9-7z",
    fill: "#d81809"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.8 193.2s-49.5-18.6-66.2-26.7c0 0-3.4-3.7-3.4-13.4s2.8-15.1-8.3-26.2c-11.1-11.1-28.4-10.8-28.4-10.8h-.5c7.5 7.9 15.4 17.6 18.6 26.4 7 19.2-8.5 29.5-8.5 29.5s35.3 15.7 44.3 24.7c2.6 2.6 4.4 5.8 5.7 9 23.7.1 41.1-1.8 46.7-12.5z",
    opacity: 0.33,
    fill: "#ff891d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.6 160.9s12.1-5.3 23.4-2.8c11.3 2.5 32.5 10 26.4 16.1s-58.4-6.5-49.8-13.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M180.1 161.9c1.4-10 .8-27.8-5.1-34.7-4-4.7-9.9-1.6-11.3 2.9-3.1 9.2 9.1 24.4 16.3 30.8 0 .3.1.6.1 1zm-11.5-31.7c1.3-1.2 2-1.5 3.1-.2 4.6 4.8 7.3 24.1 8.2 30.6-4.1-6.6-15.9-24.9-11.3-30.4zm44.3 21.8c8.2-8.5-3.2-14.3-3.3-14.4-12.1-6.2-22.6 11.2-26.1 23.3 6.9-10.9 17.8-26.8 26.5-17.6 4.3 4.1-2.5 8.2-7.8 10.8-5.9 2.8-12.3 4.8-18.7 6.8 6.7-.2 13.5-1.3 20-3.6 3.5-1.2 6.8-2.8 9.4-5.3zm-27.3 30.3c-5.2-4-5.4-12.6-5.2-19 0-.1-.8 2.2-.7 4.9.6 18.2 9.8 20.1 26.5 13.6l-1.5-2.9c-5 3-14.4 6.8-19.1 3.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M213.8 163.2L211 165c3.7 5.8 1.4 8.7 1.4 8.8-.3.3-.6 1.1-2.3 2-6.1 3.5-21.9-8.3-27.4-12.8 6 5.7 21 18.6 28.4 14.9 2.4-1.1 3-2.3 3.4-2.6 0-.2 3.6-4.3-.7-12.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M185.9 161c0 2-1.8 3.6-4 3.6s-4-1.6-4-3.6 1.8-3.6 4-3.6 4 1.7 4 3.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.223542c140432a466c948f8a2c508331.svg";
export { ForwardRef as ReactComponent };